"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.david.description': 'Tono profondo e rassicurante con gentilezza e sincerità.',
};
